import { Typography } from "@/components/ui/typography";
import formatPerisanDate from "@/utils/formatPerisanDate";
import { HugeiconsIcon } from "@hugeicons/react";
import { WeatherDay } from "./WeatherCarousel";

export const MobileWeatherSlide = ({
  day,
  lastItem,
}: {
  day: WeatherDay;
  lastItem: boolean;
}) => {
  return (
    <div className="flex items-center shrink-0 gap-1">
      <HugeiconsIcon size={20} icon={day?.icon} className={day?.className} />
      <div className="flex flex-col items-start gap-0.5">
        <Typography variant="captionRegular">
          {Math.round(day?.tempMin)}°/ {Math.round(day?.tempMax)}°
        </Typography>
        <Typography
          className="text-[10px]"
          variant="captionRegular"
          color="secondary"
        >
          {formatPerisanDate(new Date(day?.date), "M/d")}
        </Typography>
      </div>
      {lastItem ? null : <div className="w-px h-5 bg-gray-50 mr-2" />}
    </div>
  );
};
